import React from "react"
import Img from "gatsby-image"

const Product = ({ product }) => {

  return (
    <div className='col-10 col-sm-8 col-ms-6 col-lg-4 mx-auto my-3'>
      <div className="card h-100 bg-dark">
        <Img fluid={product.image.fluid} className='card-img-top img-fluid'/>
        <div className="card-body text-center d-flex flex-column">
          <h6>{product.title}</h6>
          <h6>£{product.price}</h6>
          <button className='btn btn-orange mt-3 text-capitalize snipcart-add-item mt-auto btn-block'
                  data-item-id={product.id}
                  data-item-name={product.title}
                  data-item-price={product.price}
                  data-item-image={product.image.fluid.src}
                  data-item-url='https://alchemy-live.netlify.com/'
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  )
}

export default Product
